import React from 'react';
import Navbar from './Navbar';
import "./css/Credit.css"
import Footer from './Footer';
import { CreditMain } from './CreditMain';

function Credit() {
  return (
    <div>
      <Navbar/>
      <CreditMain/>
      <Footer/>
    </div>
  )
}

export default Credit

